"use client";

import { Api } from "@/app/api";
import { Notification, NotificationResponse, UpdateNotificationDto } from "@/types";

export const NotificationApiInjection = Api.injectEndpoints({
	endpoints: (builder) => ({
		createNotification: builder.mutation<void, any>({
			query: (body) => ({
				url: "/notifications",
				method: "POST",
				body: JSON.stringify(body),
				headers: {
					"Content-Type": "application/json",
				},
			}),
			invalidatesTags: ["notifications"],
		}),

		getNotifications: builder.query<NotificationResponse, void>({
			query: () => ({
				url: "/notifications",
				headers: {
					"Content-Type": "application/json",
				},
				params: {
					pagination: false,
				},
			}),
			providesTags: ["notifications"],
		}),

		getNotification: builder.query<Notification, string>({
			query: (id) => ({
				url: `/notifications/${id}`,
				headers: {
					"Content-Type": "application/json",
				},
			}),
			providesTags: ["notifications"],
		}),
		searchNotifications: builder.query<
			{ docs: Notification[] },
			{ searchQuery?: string; sortBy?: string; page: number; limit: number }
		>({
			query: ({ searchQuery, sortBy, page, limit }) => ({
				url: `/notifications`,
				params: {
					page: page,
					limit: limit,
					search: searchQuery,
					sortBy: sortBy,
				},
				headers: {
					"Content-Type": "application/json",
				},
			}),
			providesTags: ["notifications"],
		}),
		deleteNotification: builder.mutation<void, string>({
			query: (id) => ({
				url: `/notifications/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["notifications"],
		}),

		updateNotification: builder.mutation<void, { id: string; body: UpdateNotificationDto }>({
			query: ({ id, body }) => ({
				url: `/notifications/${id}`,
				method: "PATCH",
				body: JSON.stringify(body),
				headers: {
					"Content-Type": "application/json",
				},
			}),
			invalidatesTags: ["notifications"],
		}),
		markAllNotificationsRead: builder.mutation<{ modifiedCount: number }, void>({
			query: () => ({
				url: "/notifications/read-all",
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
				},
			}),
			invalidatesTags: ["notifications"],
		}),
	}),
});

export const {
	useCreateNotificationMutation,
	useGetNotificationQuery,
	useGetNotificationsQuery,
	useSearchNotificationsQuery,
	useUpdateNotificationMutation,
	useMarkAllNotificationsReadMutation,
	useDeleteNotificationMutation,
} = NotificationApiInjection;
